
export default function PwChecker() {
  return (
    <h1>xdd</h1>
  );
}